import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import ModernHeader from '../components/Modern/ModernHeader';
import WorkflowImporter from '../components/WorkflowImporter';
import { Settings, Shield, Wrench } from 'lucide-react';

const AdminPage = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <ModernHeader 
        title="Administração" 
        subtitle="Painel de administração do sistema"
        icon={Shield}
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className={`
          ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} 
          rounded-lg border shadow-sm p-4 sm:p-8
        `}>
          <div className="text-center">
            <div className={`
              inline-flex items-center justify-center w-16 h-16 rounded-full mb-4
              ${isDarkMode ? 'bg-blue-900/20 text-blue-400' : 'bg-blue-100 text-blue-600'}
            `}>
              <Wrench className="w-8 h-8" />
            </div>
            
            <h2 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              Página de Administração
            </h2>
            
            <p className={`text-lg mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              Esta é uma página placeholder para funcionalidades administrativas.
            </p>
            
            <div className={`
              inline-flex items-center px-4 py-2 rounded-lg
              ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600'}
            `}>
              <Settings className="w-4 h-4 mr-2" />
              Pronto para personalização
            </div>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className={`
              p-6 rounded-lg border-2 border-dashed
              ${isDarkMode ? 'border-gray-600 bg-gray-700/30' : 'border-gray-300 bg-gray-50'}
            `}>
              <h3 className={`font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Área 1
              </h3>
              <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Espaço disponível para suas funcionalidades
              </p>
            </div>
            
            <div className="h-full">
              <WorkflowImporter />
            </div>
            
            <div className={`
              p-6 rounded-lg border-2 border-dashed
              ${isDarkMode ? 'border-gray-600 bg-gray-700/30' : 'border-gray-300 bg-gray-50'}
            `}>
              <h3 className={`font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Área 3
              </h3>
              <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Espaço disponível para suas funcionalidades
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;